// 🏠 HomePage - Page d'accueil du site Rock'In Agde
// Orchestre toutes les sections principales du festival
// Utilisé dans : src/App.jsx (route "/")

import FestivalHeroSection from '@/components/home/FestivalHeroSection'
import Countdown from '@/components/home/Countdown'
import StatsSection from '@/components/home/StatsSection'
import ProgramSection from '@/components/home/ProgramSection'
import LineupSection from '@/components/home/LineupSection'
import VideoSection from '@/components/home/VideoSection'
import PartnersPreview from '@/components/home/PartnersPreview'
import homeData from '@/locales/home.json'

// Séparateur visuel entre les sections
const SectionDivider = () => <div className="container mx-auto px-4 py-8"><div className="border-t border-neutral-200 dark:border-neutral-800"></div></div>

/**
 * Page d'accueil du site Rock'In Agde
 * Présente toutes les informations essentielles du festival dans l'ordre :
 * Hero, Countdown, Stats, Programme, Lineup, Vidéos, Partenaires
 */
export default function HomePage() {
  return (
    <div>
      <FestivalHeroSection />
      <Countdown targetDate="2026-06-13T21:00:00" />
      <StatsSection />
      <SectionDivider />
      <ProgramSection />
      <SectionDivider />
      <LineupSection />
      <SectionDivider />
      <VideoSection videos={homeData.videos} />
      <SectionDivider />
      <PartnersPreview />
    </div>
  )
}
